'use client';

import { ContactSupport } from './ContactSupport';
import { useContactSupport as useContactSupportHook } from '@workspace/hooks/useContactSupport';
import { ContactSupportWrapperProps } from './contact-support.types';

export function ContactSupportWrapper({ docId }: ContactSupportWrapperProps) {
  const { enabled, data, loading, error } = useContactSupportHook(docId);

  if (loading) return null;
  if (error)
    return (
      <div className="text-primary-500 text-sm mt-4 max-w-full truncate">Error loading Contact Support: {error}</div>
    );
  if (!enabled || !data) return null;

  return <ContactSupport {...data} />;
}
